import { unique } from '../../util/array';

// Import Actions
import { SET_APPLICANTS, SET_GROUP_APPLICANTS, UPDATE_APPLICANT_KEY, UPDATE_GROUP_APPLICANT_ANSWER, SET_CURRENT_APPLICANT, SET_APPLICANT_ATTENTION, SET_LAST_PROCTORING_ACTIVITY, SET_APPLICANT_PROCTORING_HANDLES, SET_APPLICANT_PROCTOR_AUDIO_ACTIVE } from './ApplicantActions';
import { SET_APPLICANT_ANSWERS } from '../Answer/AnswerActions';
import { SET_IS_FETCHING } from '../App/AppActions';
import { LOGOUT_USER } from '../User/AuthActions';

// Initial State
export const initialState = {
    data: [],
    groups: [],
    applicantsNeedAttention: [], // [{applicantId: '123', attentionType: 'general'}] // attentionType = 'general' || 'progress' || 'conversation' || 'flag'
    applicantsProctoringHandler: [], // [{proctor: 'abc', applicant: 'xyz'}, ...]
    activeProctorsAudio: [],
    currentApplicant: null,
    isFetching: false,
};

// Think to update reducers.js

const ApplicantReducer = (state = initialState, action = {}, dispatch = null) => {
    switch(action.type) {
        case SET_APPLICANTS:
            return {
                ...state,
                data: action.isSet ? action.applicants : state.data.filter(existingApplicant => !action.applicants.find(newApplicant => newApplicant._id === existingApplicant._id)).concat(action.applicants),
                isFetching: false,
            };

        case SET_GROUP_APPLICANTS:
            return {
                ...state,
                groups: action.applicants,
            };

        case UPDATE_APPLICANT_KEY:
            return {
                ...state,
                data: state.data.map(applicant => {
                    if(applicant._id === action.applicantId) {
                        return {
                            ...applicant,
                            [action.key]: action.value,
                        };
                    }
                    return applicant;
                }),
            };

        case UPDATE_GROUP_APPLICANT_ANSWER:
            return {
                ...state,
                groups: state.groups.map(applicant => {
                    if(applicant._id === action.applicantId) {
                        return {
                            ...applicant,
                            answers: (applicant.answers || []).filter(answer => !action.answers.find(answerUpdated => answerUpdated._id === answer._id)).concat(action.answers),
                        };
                    }
                    return applicant;
                }),
            };

        case SET_APPLICANT_ANSWERS:
            return {
                ...state,
                data: state.data.map(applicant => {
                    if(applicant._id === action.applicantId) {
                        return {
                            ...applicant,
                            answers: action.answers.filter(answer => answer.applicant === action.applicantId),
                        };
                    }
                    return applicant;
                }),
            };

        case SET_CURRENT_APPLICANT:
            return {
                ...state,
                currentApplicant: action.applicant,
            };

        case SET_APPLICANT_ATTENTION:
            return {
                ...state,
                applicantsNeedAttention: state.applicantsNeedAttention.filter(attention => attention.applicant !== action.applicant).concat(action.need ? [{ session: action.session, applicant: action.applicant, type: action.attentionType, data: action.data || {} }] : []),
            };

        case SET_LAST_PROCTORING_ACTIVITY:
            return {
                ...state,
                lastProctoringActivity: action.timestamp,
            };

        case SET_APPLICANT_PROCTORING_HANDLES:
            return {
                ...state,
                applicantsProctoringHandler: [
                    ...state.applicantsProctoringHandler.filter(handle => (action.proctorId ? handle.proctor !== action.proctorId : handle.session !== action.sessionId)),
                    ...action.handles,
                        // {
                        //     session: action.sessionId,
                        //     proctor: action.proctorId,
                        //     applicant: applicantId,
                        //     isHandling: action.handles[applicantId].isHandling,
                        // }
                ],
            };

        case SET_APPLICANT_PROCTOR_AUDIO_ACTIVE:
            return {
                ...state,
                activeProctorsAudio: (state.activeProctorsAudio || []).filter(activeProctorAudio => activeProctorAudio.proctor !== action.proctorId).concat({
                    session: action.sessionId,
                    proctor: action.proctorId,
                    applicant: action.applicantId,
                    isActive: action.isActive,
                }),
            };

        case SET_IS_FETCHING:
            if(action.dataType === 'applicants') {
                return {
                    ...state,
                    isFetching: action.isFetching,
                };
            }
            return state;

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};

export default ApplicantReducer;
